<template>
  <div>
    <!-- File Upload Form -->
    <form @submit.prevent="uploadFileAndCreateVisualization">
      <v-text-field 
        v-model="file"
        label="Upload your CSV file for data visualization" 
        required
        clearable
        placeholder="No file chosen" 
        full-width 
        type="file"
        @change="handleFileUpload"
        class="inputarea"
      ></v-text-field>
      <v-btn class="btn btn-primary mb-4" color="primary" type="submit">Create Visualization</v-btn>
    </form>
    
    <!-- Visualization Display -->
    <div v-if="visualizationUrls.length">
      <div class="visualization-container" v-for="(url, index) in visualizationUrls" :key="index">
        <img :src="url" alt="Data Visualization" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      file: null,
      visualizationUrls: [],
    };
  },
  methods: {
    handleFileUpload(event) {
      this.file = event.target.files[0];
    },
    async uploadFileAndCreateVisualization() {
      if (!this.file) {
        alert("Please upload a CSV file.");
        return;
      }

      try {
        // Step 1: Upload the file to your server
        const formData = new FormData();
        formData.append("file", this.file);

        const uploadResponse = await fetch(`${process.env.VUE_APP_NODE_SERVER}gpt/upload`, {
          method: 'POST',
          body: formData,
        });
        const uploadData = await uploadResponse.json();
        if (!uploadResponse.ok) throw new Error(uploadData.message);

        // Step 2: Create the Assistant with the uploaded file ID
        const assistantResponse = await fetch(`${process.env.VUE_APP_NODE_SERVER}gpt/createAssistant`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            file_id: uploadData.file_id,
          }),
        });
        const assistantData = await assistantResponse.json();
        if (!assistantResponse.ok) throw new Error(assistantData.message);

        // Step 3: Fetch visualization URLs or data from the assistant's response
        // This example assumes the assistant response includes URLs for the visualizations
        this.visualizationUrls = assistantData.visualizationUrls;
      } catch (error) {
        console.error('Error:', error);
        alert("Failed to create data visualization.");
      }
    },
  },
};
</script>
<style scoped>
.inputarea {
  margin-bottom: 20px;
}

.btn-primary {
  background-color: #007BFF;
  color: white;
}

.visualization-container {
  margin-top: 20px;
  border: 1px solid #ddd;
  padding: 10px;
  border-radius: 5px;
}

.visualization-container img {
  max-width: 100%;
  height: auto;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.loading-container img {
  width: 50px; /* Adjust based on the size of your loading spinner */
  height: 50px; /* Adjust based on the size of your loading spinner */
}

/* Button styling */
.v-btn {
  margin-right: 10px;
  color: #FFF;
}

.download-btn, .save-btn, .close-btn {
  margin-top: 10px;
}

/* Custom styles for the file input field to make it more visually appealing */
.file-input {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
}

/* Lightbox styles for viewing saved images */
.lightbox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 1050;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.lightbox img {
  max-width: 90%;
  max-height: 80%;
}

/* Adjust this path to fit the location of your spinner image */
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
